import { useRef, useCallback, useEffect } from 'react';
import { containerCls, shapeCls } from './Shape.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { RenderShape } from '../../shapes/RenderShape.js';

const Shape = ({
  sheetRef,
  pageId,
  pageAspectRatio,
  zIndex,
  item,
  isSelected,
  isCloned,
  onSelect,
  Before,
  After
}) => {
  const ref = useRef(null);
  const handleSelect = useCallback(evt => {
    if (onSelect !== undefined) {
      onSelect(evt, item);
    }
  }, [item, onSelect]);
  useEffect(() => {
    const node = ref.current;
    if (node === null) {
      return;
    }
    node.addEventListener("mousedown", handleSelect, {
      passive: false
    });
    node.addEventListener("touchstart", handleSelect, {
      passive: false
    });
    return () => {
      node.removeEventListener("mousedown", handleSelect);
      node.removeEventListener("touchstart", handleSelect);
    };
  }, [item, handleSelect]);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: containerCls,
    style: {
      zIndex,
      left: `${(item.position.x * 100).toString()}%`,
      top: `${(item.position.y * 100).toString()}%`,
      width: `${(item.size.width * 100).toString()}%`,
      height: `${(item.size.height * 100).toString()}%`,
      transform: item.angleInRadian !== 0 ? `rotate(${item.angleInRadian.toString()}rad)` : undefined
    },
    children: [Before !== undefined && /*#__PURE__*/jsx(Before, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    }), /*#__PURE__*/jsx(RenderShape, {
      type: item.type,
      className: shapeCls,
      preserveAspectRatio: "none",
      fillColor: item.style.fillColor,
      strokeColor: item.style.strokeColor
    }), After !== undefined && /*#__PURE__*/jsx(After, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    })]
  });
};

export { Shape };
//# sourceMappingURL=Shape.js.map
